import classnames from 'classnames';
import { node, string } from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import InfoTooltip from '../generic/Tooltip/InfoTooltip';
import isPermitted from '../utils/is-permitted';

function AuthorizedLink({ className, query, children, ...rest }) {
  const disabled = !isPermitted(query);
  return (
    <Link
      className={classnames(className, { disabled, 'authorized-link': true })}
      disabled={disabled}
      {...rest}
    >
      {children}
      {disabled && (
        <InfoTooltip
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
          }}
          target={`${query.method}-${query.apiName}`}
        >
          You do not have sufficient permissions to perform this action
        </InfoTooltip>
      )}
    </Link>
  );
}

AuthorizedLink.propTypes = {
  query(props, propName, componentName) {
    const query = props[propName];
    if (!query) {
      return new Error(`Missing '${propName}' for '${componentName}'.`);
    }
    if (!['GET', 'PATCH', 'POST', 'DELETE'].includes(query.method)) {
      return new Error(
        `'${propName}' for '${componentName}' does not have a valid HTTP method '${query.method}'.`,
      );
    }
    if (!query.url && typeof query.url === 'string') {
      return new Error(
        `'${propName}' for '${componentName}' does not have a valid url '${query.url}'.`,
      );
    }
    return undefined;
  },
  className: string,
  to: Link.propTypes.to, // eslint-disable-line
  children: node.isRequired,
};

AuthorizedLink.defaultProps = {
  className: '',
  query: undefined,
};

export default AuthorizedLink;
